/**
 * 必須入力チェック
 */
export const validateRequired = (value: string, fieldName: string): string => {
  if (!value.trim()) {
    return `${fieldName}は必須です`;
  }
  return '';
};

/**
 * No（行番号）のバリデーション
 *
 * 条件:
 * - 数値（必須）
 */
export const validateNo = (value: number | null): string => {
  if (value === null) {
    return 'Noは必須です';
  }
  if (Number.isNaN(value)) {
    return 'Noは数値で入力してください';
  }
  if (!Number.isInteger(value)) {
    return 'Noは整数で入力してください';
  }
  return '';
};

/**
 * ログインID（User.user_name）とパスワード（User.password）のバリデーション
 *
 * 条件:
 * - 使える文字: 半角英数字（a-z, A-Z, 0-9）、ドット（.）、ハイフン（-）、アンダースコア（_）、アットマーク（@）
 * - 文字数: 4〜64文字
 */
export const validateUsernamePassword = (value: string, fieldName: string): string => {
  const pattern = /^[a-zA-Z0-9._@-]{4,64}$/;
  if (!pattern.test(value)) {
    if (value.length < 4) {
      return `${fieldName}は4文字以上で入力してください`;
    }
    if (value.length > 64) {
      return `${fieldName}は64文字以内で入力してください`;
    }
    return `${fieldName}は半角英数字、ドット（.）、アンダースコア（_）、ハイフン（-）、アットマーク（@）のみ使用できます`;
  }
  return '';
};

/**
 * ユーザー名（表示名）のバリデーション
 *
 * 条件:
 * - 文字数: 1〜255文字
 */
export const validateUserDisplayName = (value: string): string => {
  if (!value.trim()) {
    return 'ユーザー名は必須です';
  }
  if (value.length > 255) {
    return 'ユーザー名は255文字以内で入力してください';
  }
  return '';
};

/**
 * メールアドレスのバリデーション
 */
export const validateEmail = (email: string): string => {
  if (!email.trim()) {
    return 'メールアドレスは必須です';
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'メールアドレスの形式が正しくありません';
  }
  return '';
};

/**
 * 権限のバリデーション
 *
 * 条件:
 * - 「管理者ユーザー」「閲覧ユーザー」「一般ユーザー」のいずれか、または空（空の場合は一般ユーザーとして扱う）
 */
export const VALID_ROLES = ['管理者ユーザー', '閲覧ユーザー', '一般ユーザー'];

export const validateRole = (value: string): string => {
  // 空の場合は一般ユーザーとして扱う（エラーなし）
  if (!value.trim()) {
    return '';
  }
  if (VALID_ROLES.includes(value)) {
    return '';
  }
  return '権限は「管理者ユーザー」「閲覧ユーザー」「一般ユーザー」のいずれかを指定してください';
};

/**
 * 個別上限（クレジット上限）のバリデーション
 *
 * 条件:
 * - 数値もしくは未入力（未入力の場合は上限なし）
 */
export const validateCreditLimit = (value: string | number | null): string => {
  // 未入力（null, undefined, 空文字）は許可
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numValue = typeof value === 'number' ? value : Number(value);

  if (Number.isNaN(numValue)) {
    return '個別上限は数値で入力してください';
  }

  if (numValue < 0) {
    return '個別上限は0以上の数値で入力してください';
  }

  if (!Number.isInteger(numValue)) {
    return '個別上限は整数で入力してください';
  }

  return '';
};
